<template>
    <v-flex xs6 sm3 md2 lg1 class="pa-2">
        <v-card height="100%" class="flexcard" @contextmenu.prevent="$refs.adminMenu.open">
            <DirectoryItemAdminMenu ref="adminMenu" :directory="directory"></DirectoryItemAdminMenu>

            <router-link :to="{ name: 'directory-show', params: { slug: directory.slug }}">
                <v-card-title class="justify-center grow">
                    <v-icon color="grey darken-3" class="tile-icon">folder_open</v-icon>
                </v-card-title>
            </router-link>

            <v-divider></v-divider>

            <v-card-actions class="pa-3 font-weight-medium text-truncate justify-center">
                {{ directory.name }}
            </v-card-actions>
        </v-card>
    </v-flex>
</template>

<script>
    import DirectoryItemAdminMenu from "./DirectoryItemAdminMenu";

    export default {
        name: "DirectoryItem",
        components: {DirectoryItemAdminMenu},
        props: {
            directory: {
                type: Object,
                default: null
            }
        }
    };
</script>

<style scoped lang="scss">
    a {
        flex-grow: 1;
    }
</style>
